// 通用作业流程相关状态
export default {
  namespaced: true,

  state() {
    return {
      // 任务详情
      taskDetail: '',
      // 订单状态
      orderStatus: '',
      // 任务状态
      taskStatus: '',
      // 当前位置
      currentPosition: null,
      // 单一定时器
      getPositionTimer: null
    };
  },

  mutations: {
    SET_ORDER_STATUS(state, data) {
      state.orderStatus = data;
    },
    SET_TASK_STATUS(state, data) {
      state.taskStatus = data;
    },
    SET_CURRENT_POSITION(state, data) {
      state.currentPosition = data;
    },
    SET_GETPOSITION_TIMER(state, data) {
      state.getPositionTimer = data;
    },
    SET_TASK_DETAIL(state, data) {
      state.taskDetail = data;
    }
  },

  actions: {
    setOrderStatus({ commit }, data) {
      commit('SET_ORDER_STATUS', data);
    },
    setTaskStatus({ commit }, data) {
      commit('SET_TASK_STATUS', data);
    },
    setCurrentPosition({ commit }, data) {
      commit('SET_CURRENT_POSITION', data);
    },
    setGetPositionTimer({ commit }, data) {
      commit('SET_GETPOSITION_TIMER', data);
    },
    setTaskDetail({ commit }, data) {
      commit('SET_TASK_DETAIL', data);
    }
  }
};
